import React, { Fragment, useEffect, useState } from 'react';
import QuestionView from './QuestionView';
import QuestionsMatrixView from './QuestionsMatrixView';
import { useStoreContext } from '../context/store';
import Question from '../models/Module';
import QuestionsMatrix from '../models/QuestionsMatrix';

import get from 'lodash/get';
import { getOneOf } from '../utils/objects';
import { set } from 'lodash';

const PollView = ({ deviceType, questions, answers, ...props }) => {
  const { context, dispatch } = useStoreContext();
  const { startIndex, nextStepIndex, atLastPage, freezeAutoStep, currentView } =
    context.ui;
  const { poll: encuesta } = context.data;
  const [blocked, setBlocked] = useState(false);
  const [pageStarts, setPageStarts] = useState([]);
  const [questionsPage, setQuestionPage] = useState([]);
  const pageSize = encuesta.settings.pageSize;
  const autoStep = encuesta.settings.autoStep;
  const delay = get(encuesta, 'settings.delay', 0.3);
  const appMode = get(context, 'state.appMode');
  const questionsValid = get(context, 'questionsValid', []);
  const currentQuestion = questionsValid.find(
    (question, index) => index === startIndex
  );

  // console.log("context");
  const setStartIndex = (startIndex) =>
    dispatch({
      type: 'ui.update',
      payload: {
        startIndex,
        pageSize,
      },
    });

  const setAtLastPage = (atLastPage) =>
    dispatch({
      type: 'ui.update',
      payload: {
        atLastPage,
      },
    });

  useEffect(() => {
    const questionsValid = [];
    let currentQuestion = questions[0];
    // setBlocked(false);
    // setAtLastPage(false);

    const doVars = {};

    do {
      const find = questionsValid.find((find) => find === currentQuestion);
      if (find) {
        console.error('Smile: Cycle rendundacy detected.');
        currentQuestion = undefined;
        break;
      }
      if (get(currentQuestion, 'type', 'question') !== 'thanks') {
        questionsValid.push(currentQuestion);
        const {
          nextItem: nextQuestion,
          blocked,
          isLast,
        } = currentQuestion.getNext(answers);
        Object.assign(doVars, {
          blocked,
        });
        currentQuestion = nextQuestion;
      } else {
        currentQuestion = undefined;
      }
    } while (currentQuestion);

    setBlocked(doVars.blocked);

    // console.log("QUESTIONS VALID:")
    // console.log(questionsValid);

    const pageStarts = [
      0,
      ...questionsValid
        .map((question, index) =>
          question.isBreaker() ? index + 1 : undefined
        )
        .filter((index) => index !== undefined),
    ];

    [...pageStarts].forEach((pageStartIndex, index) => {
      const nextPageStart =
        pageStarts[index + 1] !== undefined
          ? pageStarts[index + 1]
          : questionsValid.length - 1;
      const pageSizeBreaks = Math.trunc(
        (nextPageStart - pageStartIndex) / pageSize
      );

      Array.from({ length: pageSizeBreaks }).forEach((value, index) => {
        const pageSizeBreak = pageStartIndex + (index + 1) * pageSize;
        if (!pageStarts.includes(pageSizeBreak)) pageStarts.push(pageSizeBreak);
      });
    });
    pageStarts.sort((a, b) => a - b);

    setPageStarts(pageStarts);

    // console.log("pageStarts");
    // console.log(pageStarts);

    dispatch({
      type: 'questionsValid.update',
      payload: questionsValid,
    });
  }, [questions, answers]);

  useEffect(() => {
    const currentQuestion = questionsValid.find(
      (question, index) => index == startIndex
    );
    const findQuestion = answers.find(
      (answer) => answer.questionId === get(currentQuestion, 'id')
    );

    if (!get(findQuestion, 'dirty')) {
      let view = '';
      if (currentQuestion && currentQuestion.score_type == null && currentQuestion.type === 'question') {
        view = 'motives';
      } else {
        view = 'question';
      }
      dispatch({
        type: 'ui.update',
        payload: {
          currentView: view,
        },
      });
    }

    /*
      Con el startIndex actual, buscar dentro de breaks que  nextStepIndex y prevStepIndex le corresponden

    */
    const currentPageStartIndex = pageStarts.findIndex(
      (index) => index === startIndex
    );
    const nextStepIndex = pageStarts[currentPageStartIndex + 1];
    const prevStepIndex = pageStarts[currentPageStartIndex - 1];

    // console.log({
    //   prevStepIndex,
    //   startIndex,
    //   nextStepIndex,
    // })

    dispatch({
      type: 'ui.update',
      payload: {
        prevStepIndex,
        nextStepIndex,
      },
    });

    const questionsPage = questionsValid.slice(startIndex, nextStepIndex);
    setAtLastPage(
      questionsPage.reduce((ret, question) => {
        const { isLast, thanks } = question.getNext(answers);
        if (thanks) {
          dispatch({
            type: 'data.update',
            payload: {
              thanks,
            },
          });
        } else {
          if (isLast) {
            const data = context.data;
            const thanks = getOneOf(
              [data.campaign, data.device, data.encuesta],
              'metadata.thanks'
            );

            set(
              thanks,
              'redes',
              getOneOf(
                [data.campaign, data.device, data.encuesta],
                'metadata.redes'
              )
            );
            dispatch({
              type: 'data.update',
              payload: {
                thanks,
              },
            });
          }
        }

        return ret || isLast;
      }, false)
    );

    let dirty = false;

    const singleQuestions = questionsPage.reduce((reduced, question) => {
      return [...reduced, ...question.getQuestions()];
    }, []);

    singleQuestions.forEach((question) => {
      if (get(answers[question.index], 'visited') === true) return;
      dirty = true;
      answers[question.index] = {
        ...answers[question.index],
        visited: true,
      };
    });
    if (dirty) {
      dispatch({
        type: 'answers.update',
        payload: [...answers],
      });
    }

    setQuestionPage(questionsPage);
  }, [startIndex, questionsValid, pageStarts]);

  const errorsInPage = questionsPage.reduce((reduced, item) => {
    const errors = item.getErrors(answers);
    if (
      appMode === 'iframe' &&
      !errors.find((error) => error.target === 'score') &&
      errors.find((error) => error.target === 'motive') &&
      currentView === 'question'
    ) {
      return [];
    } else {
      return [...reduced, ...errors];
    }
  }, []);

  const nextStepEnabled = errorsInPage.length === 0;

  useEffect(() => {
    dispatch({
      type: 'ui.update',
      payload: {
        nextStepEnabled,
      },
    });
  }, [nextStepEnabled]);

  useEffect(() => {
    // for autostep
    const pageHaveNoRequiredQuestion =
      questionsPage.length > 0
        ? questionsPage.reduce((reduce, question) => {
            const answer = answers.find(
              (answer) => get(answer,'questionId') === get(question,'id')
            );
            return (
              reduce +
              (get(question, 'metadata.settings.required', true) ||
                (!get(question, 'metadata.settings.required', true) &&
                  get(answer, 'dirty')))
            );
          }, 0)
        : null;

    const pageStepable =
      questionsPage.length > 0
        ? questionsPage.reduce(
            (reduce, question) => reduce + question.isStepable(answers),
            0
          )
        : null;
    const nextQuestion = questionsValid[nextStepIndex];
    const answer = answers.find(
      (answer) => answer.questionId === get(nextQuestion, 'id')
    );
    const isNextQuestionWasVisited =
      get(answer, 'visited', false) && get(answer, 'dirty', false);

    if (
      !isNextQuestionWasVisited &&
      pageHaveNoRequiredQuestion !== 0 &&
      pageStepable === 0 &&
      autoStep &&
      currentQuestion.type !== 'information' &&
      currentQuestion.type !== 'attachment' &&
      nextStepEnabled &&
      !freezeAutoStep &&
      nextStepIndex !== undefined &&
      !atLastPage
    ) {
      window.scrollTo(0, 0);
      setTimeout(function () {
        return dispatch({
          type: 'ui.update',
          payload: {
            startIndex: nextStepIndex,
          },
        });
      }, delay);
    }
  }, [
    freezeAutoStep,
    nextStepEnabled,
    nextStepIndex,
    startIndex,
    questionsValid,
  ]);

  return (
    <div data-testid="questions" className={'principal'}>
      {questionsPage.map((question, index) => {
        if (question instanceof Question)
          return (
            <QuestionView
              key={question.id}
              {...{
                question,
                values: answers,
                value: answers[question.index],
                onChange: (payload) => {
                  if (
                    currentView === 'question' &&
                    currentQuestion.hasMotives() &&
                    question.score_type !== null &&
                    get(payload, 'score')
                  ) {
                    dispatch({
                      type: 'ui.update',
                      payload: {
                        currentView: 'motives',
                      },
                    });
                  }
                  props.onChangePregunta(payload, question.index);
                },
              }}
            />
          );
        if (question instanceof QuestionsMatrix)
          return (
            <QuestionsMatrixView
              key={index}
              {...{
                questions: question.questions,
                questionsMatrix: question,
                values: answers,
                onChangePregunta: props.onChangePregunta,
              }}
            />
          );
        return null;
      })}
    </div>
  );
};

export default PollView;
